export default __webpack_public_path__ + "static/media/security-small.f006bfd8.svg";